<template>
  <a-modal
    :visible="visible"
    title="核验结果"
    :width="800"
    :footer="null"
    @cancel="handleCancel"
    :bodyStyle="{ padding: '0' }"
  >
    <div class="drugTraceRecordBody">
      <div v-for="(item, index) in list" :key="index">
        <!-- :isFirstNonPlatform="index === firstNonPlatformIndex" -->
        <DrugTraceCard :drugTraceRecord="item" :isFirstNonPlatform="false" />
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import { ref, defineExpose, defineProps, watch, computed } from 'vue'
import DrugTraceCard from './DrugTraceCard.vue'
const props = defineProps({
  list: {
    type: Array,
    default: () => []
  }
})

const visible = ref(false)

const firstNonPlatformIndex = computed(() => {
  return props.list.findIndex(item => item.drugSourceType !== 1)
})

watch(
  () => props.list,
  list => {
    console.log('list', list)
  }
)

const setVisible = data => {
  visible.value = data
}

const handleCancel = () => {
  setVisible(false)
}

defineExpose({
  setVisible
})
</script>

<style scoped lang="scss">
.drugTraceRecordBody {
  padding: 18px 24px;
  background-color: #f5f5f5;
  max-height: 621px;
  overflow: auto;
}
</style>
